"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'reports/v1/domains';

var DomainsAPI =
/*#__PURE__*/
function () {
  function DomainsAPI() {
    (0, _classCallCheck2.default)(this, DomainsAPI);
  }

  (0, _createClass2.default)(DomainsAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(API_BASE, {
        query: {
          includeHostedDomains: true
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete(domain) {
      return _apiClient.default.delete(API_BASE + "/" + domain);
    }
  }, {
    key: "put",
    value: function put(domain) {
      return _apiClient.default.put(API_BASE + "/" + domain);
    }
  }]);
  return DomainsAPI;
}();

exports.default = DomainsAPI;
module.exports = exports.default;